import { Container } from '@almbrand/container';
import { Headline } from '@almbrand/headline';
import { Paragraph } from '@almbrand/paragraph';
import { RichText } from '@almbrand/richtext';
import { LoadingSpinner } from 'components/1-atoms/LoadingSpinner';
import { HttpStatusCode, ThemeNames } from 'constantsValues';
import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { fetchParty } from 'store/slices/partySlice';
import { getStatusMessage } from 'utilities/statusMessageUtils';

import { useThemeName } from 'hooks/useThemeName';
import styles from './PartyComponent.module.scss';

export interface PartyComponentProps {
	contentType?: string;
	contentId?: number;
	title?: string;

	statusMessages?: {
		items: Array<{
			content: {
				statusMessage: string;
				statusCode: HttpStatusCode;
			};
		}>;
	};
}

const PartyComponent: React.FC<PartyComponentProps> = ({ contentType, contentId, title, statusMessages }) => {
	const dispatch = useAppDispatch();
	const partyData = useAppSelector((state) => state.party.data);
	const status = useAppSelector((state) => state.party.status);
	const trackingThemeName = useThemeName();
	const isAlmbrand = trackingThemeName === ThemeNames.almbrand;
	const { first_name, last_name, company_name } = partyData || {};

	const partyName = first_name || last_name || company_name;

	useEffect(() => {
		if (status == HttpStatusCode.Idle) {
			dispatch(fetchParty());
		}
	}, [status, dispatch]);

	return (
		<Container
			desktopWidth='1440'
			tabletWidth='fullWidth'
			mobileWidth='fullWidth'
			align='left'
		>
			{status == HttpStatusCode.Loading && <LoadingSpinner />}

			{status == HttpStatusCode.OK && partyData && (
				<>
					{isAlmbrand ? (
						<div className={styles.Party__headline}>
							<Paragraph
								text='Mit Alm. Brand Erhverv'
								paragraphType={{ size: 'default', kind: 'label' }}
							/>

							<RichText description={`<h1><span>Velkommen </span>${partyName}</h1>`} />
						</div>
					) : (
						<>
							<Headline
								title={`Hej ${partyName}`}
								size='sm'
								variant='h1'
								fontColor='primary'
							/>

							<Paragraph
								text={title}
								fontColor='primaryDark'
								paragraphType={{
									type: 'standfirst',
									kind: 'title',
								}}
								className={styles.party_subHeadline}
							/>
						</>
					)}
				</>
			)}

			{(status == HttpStatusCode.InternalServerError || status == HttpStatusCode.NoContent) && (
				<RichText description={getStatusMessage(statusMessages, status)} />
			)}
		</Container>
	);
};

export default PartyComponent;
